export default __webpack_public_path__ + "static/media/51.e59234ff.png";